var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"video my-20 border-t border-slate-200"},[_c('Container',[_c('SectionHeader',[_vm._v("Video")]),_c('div',[_c('HMTVideoProvider',[_c('PlayButton')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }